<template>
  <div id="__nc" style="width:100%;">
    <div :id="id"></div>
  </div>
</template>

<script>
import noCaptcha from "noCaptcha";
export default {
  name: "machineCheck",
  data() {
    return {
      platform: "",
      isWeChat: false,
      nc: ''
    };
  },
  mounted() {
    this.check();
  },
  props: {
    id: {
      type: String,
      default: "sms-slider"
    },
    isEnabled: {
      type: Number,
      default: () => 0
    }
  },
  methods: {
    // 机型系统判断
    check() {
      let _that = this;
      // 实例化nc
      // const nc_token = ["你申请的appKey", (new Date()).getTime(), Math.random()].join(':')
      const nc_token_sms = [
        "FFFF0N0000000000A38F",
        new Date().getTime(),
        Math.random()
      ].join(":");
      const ncsms = new noCaptcha({
        renderTo: `#${this.id}`,
        appkey: "FFFF0N0000000000A38F",
        scene: "nc_login",
        token: nc_token_sms,
        customWidth: 430,
        trans: { key1: "code0" },
        elementID: ["usernameID"],
        is_Opt: 0,
        language: "cn",
        isEnabled: true,
        timeout: 3000,
        times: 5,
        apimap: {
          // 'analyze': '//a.com/noCaptcha/analyze.jsonp',
          // 'get_captcha': '//b.com/get_captcha/ver3',
          // 'get_captcha': '//pin3.aliyun.com/get_captcha/ver3'
          // 'get_img': '//c.com/get_img',
          // 'checkcode': '//d.com/captcha/checkcode.jsonp',
          // 'umid_Url': '//e.com/security/umscript/3.2.1/um.js',
          // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
          // 'umid_serUrl': 'https://g.com/service/um.json'
        },
        callback: function(data) {
          // flag1 = true;
          // var sessionId = data.csessionid + "," + data.sig + "," + data.token + "," + "nc_login";
          // $("#smsSessionId").val(sessionId);
          //
          // $("#telSubmit").addClass("sub").removeClass("subDisabled").attr("disabled", false);
          //
          // $("#nc_2__scale_text").addClass("nc-align-center") // 解决插件样式bug
          let sessionId =
            data.csessionid +
            "," +
            data.sig +
            "," +
            data.token +
            "," +
            "nc_login";
          let obj = {
            id: _that.id,
            sessionId: sessionId
          };
          _that.$emit("ncData", obj);
          // data.nc_token = nc_token_sms;
          // data.scene = "nc_message_h5";
          // let dataArr = data;
          // _that.$emit("ncData", dataArr);
          // if (_that.logVal === 1) {
          //   _that.childMethod();
          // }
          // if (_that.platform === "ios") {
          //   window.webkit.messageHandlers.getNcData.postMessage(
          //     JSON.stringify(dataArr)
          //   );
          // } else if (_that.platform === "android") {
          //   window.js.getNcData(JSON.stringify(dataArr));
          // }
        },
        error: function(s) {}
      });
      this.nc = ncsms
      ncsms.upLang("cn", {
        _startTEXT: window.$t('page.applyUsername.btn.msg1'), // 请按住滑块，拖动到最右侧
        _yesTEXT: window.$t('page.applyUsername.btn.msg2'), // 验证通过
        _noTEXT:window.$t('page.applyUsername.btn.msg4'), // 验证不通过
        _error300:
          window.$t('page.applyUsername.btn.msg5')+'<a href="javascript:__nc.reset()">'+window.$t('page.applyUsername.btn.msg6')+'</a>'+window.$t('page.applyUsername.btn.msg7'),
        _errorNetwork:
          window.$t('page.applyUsername.btn.msg8')+'<a href="javascript:__nc.reset()">'+window.$t('page.applyUsername.btn.msg9')+'</a>',
        LOADING: window.$t('page.applyUsername.btn.msg3'), //加载
        SLIDER_LABEL: "请向右滑动验证", //等待滑动
        CHECK_Y: "验证通过", //通过
        ERROR_TITLE: "非常抱歉，这出错了...", //拦截
        CHECK_N: "验证未通过", //准备唤醒二次验证
        OVERLAY_INFORM: "经检测你当前操作环境存在风险，请输入验证码", //二次验证
        TIPS_TITLE: "验证码错误，请重新输入" //验证码输错时的提示
      });
    },
    childMethod() {
      // console.log(this.$parent.$parent)
      this.$parent.$parent.reSendCode();
    },
  },
  watch: {
    isEnabled(val) {
      console.log(val)
      if(val !== 0) {
        this.nc.reset()
      }
    }
  }
};
</script>
<style lang="scss">
.nc_scale {
  height: 42px !important;
  .btn_ok {
    line-height: 42px !important;
  }
  .scale_text {
    line-height: 42px !important;
  }
  span {
    height: 40px !important;
    line-height: 40px !important;
  }
}
</style>
